import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { secondaryMarketRtQuoteTabContentPersisted } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';
import type { EpicWithThunk } from 'state/state.common';

export function persistRtQuoteTabContentEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { updateTabContent } = tabsApiConnector(httpClient, 'secondaryMarketQuotes');

    return actions$.pipe(
      ofType('SECONDARY_MARKET_RT_QUOTE_TAB_CONTENT_PERSIST_REQUESTED'),
      mergeMap(action => {
        return updateTabContent(action.tabId, {
          ...action.tabContent,
          workspace: 'secondaryMarketQuotes',
          tabType: 'realtimeQuote',
        }).pipe(
          map(
            () => secondaryMarketRtQuoteTabContentPersisted(action.tabId, action.tabContent),
            catchError(_ => EMPTY),
          ),
        );
      }),
    );
  };
}
